import config from '@/config'

export default {
  combine: {
    confirm_password: "Confirmar contraseña",
    change_password: "Cambiar contraseña",
    old_password: "@:ui.password anterior",
    new_password: "@:ui.password nueva",
    confirm_security_code: "Confirmar @:ui.security_code",
    first_time_login: "Inicio de sesión por primera vez",
    security_authentication: "Autenticación de seguridad",
    update_security: "Actualizar seguridad",
    disable_security: "Desactivar seguridad",
    add_account: "Agregar cuenta",
    add_sub_account: "Agregar subcuenta",
    edit_operator: "Editar operador",
    edit_account: "Editar cuenta",
    edit_member: "Editar miembro",
    approve_ticket: "Aprobar ticket",
    reject_ticket: "Rechazar ticket",
    add_bank_account: "Agregar cuenta bancaria",
    edit_bank_account: "Editar cuenta bancaria",
    reset_threshold: "Restablecer umbral",
    adjust_balance: "Ajustar saldo",
    adjust_member: "Ajustar miembro",
    configure_bank_setting: "Configurar ajustes bancarios",
    account_setup: "Configuración de cuenta",
    bank_transfer: "Transferencia bancaria",
    edit_bank_member: "Editar miembro bancario",
    edit_ticket: "Editar ticket",
    edit_vip: "Editar VIP",
    knock_off_promo: "Eliminar promoción",
    edit_authority: "Editar permisos",
    reset_password: "Restablecer contraseña",
    update_password: "Actualizar contraseña",
    member_summary: "Resumen del miembro",
    reply_review: "Responder reseña",
    edit_affiliate: "Editar afiliado",
    edit_bank_affiliate: "Editar banco del afiliado",
    approve_affiliate_ticket: "Aprobar ticket de afiliado",
    check_free_spin: "Verificar giros gratis",
    reject_affiliate_ticket: "Rechazar ticket de afiliado",
    wallet_adjust: "Ajustar billetera",
    update_comm_package: "Actualizar paquete de comisión",
    approve_affiliate: "Aprobar afiliado",
    sub_acc_detail_affiliate: "Detalle de subcuenta de afiliado",
    get_tac: "Obtener OTP",
    add_coupon: "Agregar cupón",
    update_coupon: "Actualizar cupón",
    issue_free_spin: "Emitir giros gratis",
    get_bank_tac: "Obtener OTP bancario",
    update_global_setting: "Actualizar configuración global",
    add_platform: "Agregar plataforma",
    edit_platform: "Editar plataforma",
    add_bank_group: "Agregar grupo bancario",
    edit_bank_group: "Editar Grupo Bancario",
    update_maintenance_schedule: "Actualizar el programa de mantenimiento",
    add_withdrawal_limit: "Agregar límite de retiro",
    edit_withdrawal_limit: "Editar límite de retiro",
    add_campaign: "Añadir campaña",
    edit_campaign: "Editar campaña",
    add_promo_group: "Agregar grupo de promoción",
    edit_promo_group: "Editar grupo de promoción",
    update_team: "Equipo de actualización",
    update_result: "Resultado de la actualización",
    insert_result: "Insertar resultado",
    bet_list: "Lista de apuestas",
    result_list: "Lista de resultados",
    add_promo: "Añadir promoción",
    raise_deposit_ticket: "Aumentar ticket de depósito",
    bank_adjust: "Ajuste bancario",
    promo_member_assign: "Asignación de miembros de la promoción",
    bonus_issue: "Emisión de bonos",
    update_vip: "Actualización VIP",
    update_member_profile: "Actualizar perfil de miembro",
    change_withdrawal_limit: "Cambiar el límite de retiro",
    change_bank_group: "Grupo Banco del Cambio",
    change_promotion_group: "Grupo de Promoción del Cambio",
    edit_promo_signup: "Editar registro de promoción",
    update_provider_bet_limit: "Actualizar el límite de apuesta del proveedor",
    update_bet_limit: "Actualizar límite de apuesta",
    update_member_bet_limit: "Actualizar el límite de apuesta de los miembros",
    edit_bank_account_group: "Editar grupo de cuentas bancarias",
    redeposit_ticket: "Boleto de redepósito",
    edit_promotion_group: "Editar grupo de promoción",
    edit_promotion_group_norm: "Gestionar la promoción en grupo",
    get_inbox_list: "Obtener lista de bandeja de entrada",
    view_result_changes_detail: "Ver detalle de cambios en los resultados",
    edit_promotion_signup: "Editar registro de promoción",
    edit_bet_limit: "Editar límite de apuesta",
    edit_provider_game_off: "Editar proveedor de juego desactivado",
    edit_provider_rtp: "Editar RTP del proveedor",
    get_rebate: "Obtener reembolso",
    get_recent_deposit: "Obtener depósito reciente",
    add_survey: "Agregar encuesta",
    add_announcement_banner: "Agregar banner de anuncio",
    edit_announcement_banner: "Editar banner de anuncio",
    move_announcement_banner: "Mover banner de anuncio",
    add_promotion_banner: "Agregar banner de promoción",
    edit_promotion_banner: "Editar banner de promoción",
    move_promotion_banner: "Mover banner de promoción",
    add_slide_banner: "Agregar banner de diapositivas",
    edit_slide_banner: "Editar banner de diapositivas",
    move_slide_banner: "Mover banner de diapositiva",
    add_seo_page: "Agregar página SEO",
    edit_seo_page: "Editar página SEO",
    clear_outstanding: "Claro Pendiente",
    add_ip_whitelist: "Agregar lista blanca de IP",
    bonus_issue_bulk: "Emisión masiva de bonos",
    edit_bank_member_ewallet: "Editar miembro del banco (billetera electrónica)",
    redeposit: "Volver a depositar",
    reject_approved_ticket: "Rechazar boleto aprobado",
    audit_ticket: "Ticket de auditoría",
    review_ticket: "Revisar Ticket",
    edit_promotion_group_norm_seq: "Administrar la secuencia de promoción en el grupo",
    edit_promo_provider_list: "Editar lista de proveedores de promoción",
    edit_promo_payment_option: "Editar opción de pago de la promoción",
    edit_campaign_provider_list: "Editar lista de proveedores de campaña",
    update_comm: "Comisión de Actualización",
    update_carry_over: "Transferencia de actualización",
    review_affiliate_ticket: "Revisar Ticket de Afiliado",
    audit_affiliate_ticket: "Auditar Ticket de Afiliado",
    get_tac_affiliate: "Obtener OTP (Afiliado)",
    raise_deposit_ticket_gateway: "Levantar Ticket de Depósito (Gateway)",
    direct_audit_ticket: "Ticket de Auditoría (Directo)",
    get_rollback_detail: "Obtener detalles de reversión",
    get_reject_detail: "Obtener detalle de rechazo",
    manual_approve_ticket: "Aprobar ticket (manual)",
    add_label: "Agregar etiqueta",
    edit_label: "Editar etiqueta",
    rollback_processing_ticket: "Ticket de procesamiento de reversión",
    update_iframe_url: "Actualizar URL de iframe",
    edit_exchange_rate: "Editar tipo de cambio",
    add_vip: "Añadir VIP",
    add_turnover_tier: "Agregar nivel de facturación",
    edit_turnover_tier: "Editar nivel de facturación",
    get_member_label_list: "Lista de etiquetas de miembros",
    add_rescue_fund: "Agregar Fondo de Rescate",
    get_custom_member_list: "Lista de miembros personalizada",
    get_rescue_fund_provider: "Obtener Proveedor de Fondos de Rescate",
    add_game_exclude: "Agregar exclusión de juego",
    delete_game_exclude: "Eliminar juego Excluir",
    domain_custom_add_assign: "Agregar dominio",
    add_domain_batch: "Agregar dominio (lote)",
    update_payment_provider_vip: "Actualizar Proveedor de Pago Vip",
    update_campaign: "Campaña de actualización",
    purchase_domain: "Compra de dominio",
    apply_domain: "Aplicar dominio",
    edit_access_control: "Editar control de acceso",
    add_domain: "Añadir dominio",
    operator_wallet_adjust: "Ajustar la billetera del operador",
    update_payment_provider_desc: "Actualizar la descripción del proveedor de pagos",
    add_package: "ui.add @:ui.package",
    edit_package: "ui.edit @:ui.package",
    add_theme_content: "ui.add @:ui.theme_content",
    edit_theme_content: "ui.edit @:ui.theme_content",
    add_theme: "ui.add @:ui.theme",
    edit_theme: "ui.edit @:ui.theme",
    add_color: "ui.add @:ui.color",
    edit_color: "ui.edit @:ui.color",
    add_content: "@:ui.add @:ui.content",
    edit_content: "@:ui.edit @:ui.content",
    delete_content: "@:ui.delete @:ui.content",
    update_setting: "@:ui.update @:ui.setting",
    add_theme_content_group: "@:ui.add @:ui.theme_content_group",
    edit_theme_content_group: "@:ui.edit @:ui.theme_content_group",
    add_bo_default_domain: "@:ui.add @:ui.bo_default_domain",
    edit_bo_default_domain: "@:ui.edit @:ui.bo_default_domain",
    update_theme: "@:ui.update @:ui.theme",
    update_menu: "@:ui.update @:ui.menu",
    update_game_menu: "@:ui.update @:ui.game_menu",
    update_special_menu: "@:ui.update @:ui.special_menu",
    update_setting_menu: "@:ui.update @:ui.setting_menu",
    update_profile_setting: "@:ui.update @:ui.profile_setting",
    update_operator_setting: "@:ui.update @:ui.operator_setting",
    add_social_account: "@:ui.add @:ui.social_account",
    edit_social_account: "@:ui.edit @:ui.social_account",
    add_site_info: "@:ui.add @:ui.site_info",
    edit_site_info: "@:ui.edit @:ui.site_info",
    add_ads: "@:ui.add @:ui.advertisement",
    edit_ads: "@:ui.edit @:ui.advertisement",
    edit_provider_hot_game: "@:ui.edit @:ui.provider @:ui.hot_game",
    edit_provider_new_game: "@:ui.edit @:ui.provider @:ui.new_game",
    edit_provider_popular_game: "@:ui.edit @:ui.provider @:ui.popular_game",
    edit_provider_featured_game: "@:ui.edit @:ui.provider @:ui.featured_game",
    setup_logo: "Logotipo de configuración",
    add_livechat: "@:ui.add @:ui.livechat",
    update_livechat: "@:ui.update @:ui.livechat",
    provider_pt_operator_update: "Actualización del operador de PT del proveedor",
    provider_pt_global_update: "Actualización global de PT para proveedores",
    payment_option_callback_update: "Actualización de URL de devolución de llamada",
    change_payment_option_seq: "Secuencia de opciones de pago",
    change_payment_mode_status: "Actualización del estado de la opción de pago",
    change_payment_option_recommend: "Opción de pago recomendada",
    change_payment_option_credential: "Credencial de opción de pago",
    change_payment_option_limit: "Límite de opciones de pago",
    change_payment_option_vip: "Opción de pago VIP",
    add_mini_game: "@:ui.add @:ui.mini_game",
    edit_mini_game: "@:ui.edit @:ui.mini_game",
    add_mini_game_template: "@:ui.add @:ui.mini_game_template",
    edit_mini_game_template: "@:ui.edit @:ui.mini_game_template",
    edit_reward: "@:ui.edit @:ui.reward",
    gamify_update: "@:ui.update @:ui.reward",
    add_free_game_token: "@:ui.add @:ui.free_game_token",
    add_partners: "@:ui.add @:ui.partners",
    edit_partners: "@:ui.edit @:ui.partners"
  },
  short: {
    deposit_amount: "Dep Amt",
    base_amount: "Base Amt",
    bonus_amount: "Bono Amt",
    target_amount: "Trgt Amt",
    knockoff_by: "K.O By",
    knockoff_date: "Fecha K.O",
    incoming_threshold: "EN TRES",
    incoming_frequency: "EN FREQ",
    outgoing_threshold: "FUERA TRES",
    outgoing_frequency: "FUERA FREQ",
    account_balance: "ACC BAL",
    claim_type: "Tipo C",
    bonus_rate: "Tarifa B",
    max_bonus: "M.Bonus",
    rollover: "Rollover",
    criteria: "Criterios",
    start_time: "S.Tiempo",
    end_time: "E.Tiempo",
    monday: "LUNES",
    tuesday: "MAR",
    wednesday: "MIERCOLES",
    thursday: "JUE",
    friday: "VIERNES",
    saturday: "SAT",
    sunday: "SOL",
    status: "Estado",
    bonus_rate_percent: "Tasa B (%)",
    valid_turnover: "V. Volumen de negocios",
    deposit_count: "Dep Cnt",
    withdrawal_amount: "Wdw Amt",
    withdrawal_count: "Wdw Cnt",
    adjustment_amount: "Adj Amt",
    referee_count: "Árbitro Cnt",
    signup_count: "Regístrese Cnt",
    verified_count: "Recuento de VRF",
    active_member: "MBM activo",
    ftd_count: "FTD Cnt",
    ftd_amount: "FTD Amt",
    working_date: "DT de trabajo",
    recipient_bank_id: "R.ID del Banco",
    recipient_bank_acc_no: "R.Bank Acc No.",
    recipient_bank_acc_holder: "Titular de R.Bank Acc",
    sender_bank: "S.Banco",
    sender_bank_acc_no: "S.Bank Acc No.",
    sender_bank_acc_holder: "Titular de la cuenta de S.Bank",
    unique_login_count: "u.login cnt",
    unique_deposit_count: "U.Dep Cnt",
    unique_withdrawal_count: "U.Wdw Cnt",
    second_deposit_count: "S.Dep Cnt",
    reject_date: "R.Fecha",
    processing_date: "P.Fecha",
    deposit_withdrawal_different: "Dep Wdw diff",
    external_id: "Ej. ID",
    draft_version: "Borrador. Ver.",
    prod_version: "Prod. Ver.",
    purchased_date: "P. Fecha",
    completed_amount: "Compl Amt"
  },
  date_ranges: {
    0: "Hoy",
    1: "Ayer",
    2: "Este mes",
    4: "El mes pasado",
  },
  langList: {
    EN: "Inglés",
    CN: "Chino",
    PHP: "Philippines",
    esp: "Español",
    RUS: "Ruso",
    VI: "Vietnamita",
    MS: "Malayo",
    NE: "Nepalí"
  },
  menulist: {
    home: "Inicio",
    hot: "Caliente",
    slot_game: "Tragamonedas",
    casino: "Casino",
    sportsbook: "Deportes",
    fishing: "Pesca",
    lottery: "Lotería",
    poker: "Póquer",
    hash_game: "Juego de hash",
    sabong: "Sabong",
    promotion: "Promoción",
    review: "Revisión",
    news: "Noticias",
    live_stream: "Transmisión en vivo",
    vip: "VIP",
    referral: "Referencia",
    favourite: "Favorito",
    mission: "Misión (Minijuego)",
    spin: "Girar",
    leaderboard: "Tabla de clasificación",
    account: "Cuenta",
    deposit: "Depósito",
    withdrawal: "Desistimiento",
    bet_history: "Historial de apuestas",
    pending_status: "Estado pendiente",
    change_password: "Cambiar contraseña",
    profile: "Perfil",
    banking_details: "Datos bancarios",
    inbox: "Bandeja de entrada",
    voucher: "Cupón",
    wallet: "Cartera",
    statement: "Declaración",
    download: "Descargar",
    game: "Juego",
    special: "Especial",
    misc: "Varios",
    contact_us: "Contáctenos",
    e_sportsbook: "E-Sportsbook",
    lotto: "Lotería",
    p2p: "P2P",
    other: "Otros",
    vip2: "VIP2",
    referral2: "Referencia2",
    event: "Evento",
    daily_reward: "Recompensa diaria",
    play2earn: "Juega 2 Gana",
    redemption: "Redención",
    card_board: "Cartulina",
    lobby: "Vestíbulo",
    in_house: "En casa",
    transfer: "Transferencia",
    horse_racing: "Carreras de caballos",
    register: "Registrarse",
    login: "Iniciar sesión",
    transaction_history: "Historial de transacciones",
    bingo: "Bingo",
    member: "Miembro",
    arcade: "Arcade",
    crash: "Choque",
  },

  ok: "Está bien",
  cancel: "Cancelar",
  login: "Iniciar sesión",
  logout: "Cerrar sesión",
  add: "Agregar",
  edit: "Editar",
  delete: "Eliminar",
  refresh: "Actualizar",
  action: "Acción",
  id: "ID",
  name: "Nombre",
  all: "Todos",
  search: "Buscar",
  remove: "Eliminar",
  save: "Guardar",
  account: "Cuenta",
  settings: "Ajustes",
  on: "ENCENDIDO",
  off: "APAGADO",
  new: "Nuevo",
  clear: "Claro",
  users: "Usuario | Usuarios",
  username: "Nombre de usuario",
  password: "Contraseña",
  created_on: "Crear en",
  active: "Activo",
  page_size: "Tamaño de página",
  status: "Estado",
  result: "Resultado",
  close: "Cerca",
  back: "Atrás",
  show: "Mostrar",
  login_id: "ID de inicio de sesión",
  date_time: "FechaHora",
  ip_address: "Dirección IP",
  domain_name: "Nombre de dominio",
  browser_agent: "Agente del navegador",
  action_by: "Acción de",
  details: "Detalles",
  key: "Clave | Claves",
  value: "Valor | Valores",
  from: "Desde",
  to: "Para",
  type: "Tipo",
  criteria: "Criterios",
  log: "Registro",
  report: "Informe",
  security_tag: "Etiqueta de seguridad",
  security_code: "Código de seguridad",
  submit: "Enviar",
  disable: "Deshabilitar",
  operators: "Operador | operadores",
  members: "Miembros",
  account_id: "ID de cuenta",
  confirm_password: "Confirmar contraseña",
  full_name: "Nombre completo",
  contact_phone: "Teléfono de contacto",
  contact_email: "Correo electrónico de contacto",
  dashboard: "Panel de control",
  sub_account: "Subcuenta",
  authority_option: "Opción de autoridad",
  banks: "Banco | Bancos",
  login_ip : "IP de inicio de sesión",
  block: "Bloquear",
  profile_id: "ID de perfil",
  suspend: "Suspender",
  dob: "Fecha de nacimiento",
  mail_address: "Dirección de correo electrónico",
  deposit: "Depósito",
  withdrawal: "Desistimiento",
  rejected: "Rechazado",
  processed: "Procesado",
  pending: "Pendiente",
  member: "Miembro",
  amount: "Cuantía",
  bank_acc_no: "Nº de cuenta bancaria",
  deposit_date: "Fecha de depósito",
  deposit_method: "Método de depósito",
  approve: "Aprobar",
  reject: "Rechazar",
  remark: "Observación",
  ticket_detail: "Detalle del billete",
  promo: "Promoción",
  package: "Paquete",
  created_date: "Fecha de creación",
  currency: "Moneda",
  bank_acc_holder: "Titular de la cuenta bancaria",
  ref_no: "Nº de referencia",
  vip: "VIP",
  modified_date: "Fecha de modificación",
  modified_by: "Modificado por",
  bank_member: "Miembro del Banco",
  bank_operator: "Operador Bancario",
  bank_name: "Nombre del banco",
  bank_acc_type: "Tipo de cuenta bancaria",
  account_balance: "Saldo de la cuenta",
  threshold: "Umbral",
  incoming: "Entrante",
  outgoing: "Extrovertido",
  frequency: "Frecuencia",
  reset_threshold: "Restablecer umbral",
  adjust_balance: "Ajustar saldo",
  bank_from: "Banco de",
  bank_to: "Banco a",
  attachment: "Adjunto",
  sender_bank: "Banco Remitente",
  sender_bank_acc_no: "Nº de cuenta del banco remitente",
  sender_bank_acc_holder: "Titular de la cuenta del banco remitente",
  audit: "Auditoría",
  action_status: "Estado de la acción",
  action_date: "Fecha de acción",
  promotion: "Promoción",
  promo_id: "ID de promoción",
  promo_name: "Nombre promocional",
  package_id: "ID del paquete",
  claim_type: "Tipo de reclamación",
  bonus_rate: "Tasa de bonificación",
  max_bonus: "Bono máximo",
  rollover: "Rollover",
  start_date: "Fecha de inicio",
  end_date: "Fecha de finalización",
  adj_amount: "Ajustar cantidad",
  promotion_member: "Miembro de la Promoción",
  on_going: "En curso",
  knock_off: "Imitación",
  all_ongoing: "Todo en curso",
  deposit_amount: "Monto del depósito",
  base_amount: "Monto Base",
  bonus_amount: "Monto de la bonificación",
  target_amount: "Importe objetivo",
  claim_date: "Fecha de reclamación",
  accumulate_win: "Acumular ganancia",
  accumulate_turnover: "Acumular volumen de negocios",
  bonus: "Bonificación",
  bonus_log: "Registro de bonificación",
  member_id: "ID de miembro",
  before_balance: "Antes del saldo",
  transfer_amount: "Monto de la transferencia",
  after_balance: "Después del balance",
  created_by: "Creado por",
  bonus_name: "Nombre del bono",
  bonus_desc: "Descripción del bono",
  bonus_type: "Tipo de bonificación",
  add_promo: "Añadir promoción",
  bonus_value: "Valor de bonificación",
  attach_promo: "Adjuntar Promoción",
  daily_statement: "Comunicado Diario",
  working_date: "Fecha de trabajo",
  opening_balance: "Saldo de apertura",
  turnover: "Volumen de negocios",
  valid_turnover: "Volumen de negocios válido",
  winlose: "WinLose",
  withdrawal_amount: "Monto de retiro",
  closing_balance: "Balance de cierre",
  sub_total: "Sub Total",
  grand_total: "Gran Total",
  daily_winlose: "Pérdida diaria",
  game_result_slots: "Resultado del juego (tragamonedas)",
  game_result_livecasino: "Resultado del juego (Livecasino)",
  game_result_rebate: "Resultado del juego (reembolso)",
  game_result_sportsbook: "Resultado del juego (casa de apuestas)",
  game_result_cockfight: "Resultado del juego (pelea de gallos)",
  game_result_rescue: "Resultado del juego (rescate)",
  bet_count: "Recuento de apuestas",
  result_id: "ID de resultado",
  bet_time: "Tiempo de apuesta",
  payout: "Pago",
  game_type: "Tipo de juego",
  game_name: "Nombre del juego",
  game_provider: "Proveedor de juegos",
  reset: "Restablecer",
  mode: "Modo",
  balance: "Equilibrio",
  min_bal_knock_off_promo: "Min Bal. (A la promoción de imitación automática)",
  social_account: "Cuenta Social",
  wechat: "Wechat",
  telegram: "Telegrama",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  login_log: "Registro de inicio de sesión",
  platform: "Plataforma",
  bank_statement: "Estado de cuenta bancario",
  transfer_date: "Fecha de transferencia",
  detail: "Detalle",
  date: "Fecha",
  transfer_list: "Lista de transferencias",
  credit: "Crédito",
  debit: "Débito",
  month: "Mes",
  unblock: "Desbloquear",
  unblock_member: "Desbloquear miembro",
  unblock_operator: "Operador de desbloqueo",
  referrer_id: "ID de referencia",
  referrer_code: "Código de referencia",
  referral_code: "Código de referencia",
  bonus_and_adjustment: "Bonificación y ajuste",
  adjustment: "Ajuste",
  incoming_amount_threshold: "Umbral de importe entrante",
  outgoing_amount_threshold: "Umbral de Importe de Salida",
  knock_off_by: "Knock Off Por",
  knock_off_date: "Fecha de eliminación",
  total_turnover: "Facturación total",
  total_winlose: "Victoria total",
  total_deposit: "Depósito Total",
  total_member: "Miembro Total",
  active_player: "Jugador activo",
  top_winner: "Máximo ganador",
  top_loser: "Mejor perdedor",
  winner: "Ganador",
  loser: "Perdedor",
  deposit_count: "Recuento de depósitos",
  withdrawal_count: "Recuento de retiros",
  alert: "Alerta",
  incoming_threshold: "Umbral de entrada",
  incoming_frequency: "Frecuencia de entrada",
  outgoing_threshold: "Umbral de salida",
  outgoing_frequency: "Frecuencia de salida",
  reset_password: "Restablecer contraseña",
  transfer: "Transferencia",
  company_bank: "Banco de la empresa",
  company_bank_acc_no: "Nº de cuenta del banco de la empresa",
  company_bank_acc_holder: "Titular de la cuenta del banco de la empresa",
  registered_member: "Miembro Registrado",
  promotion_report: "Informe de Promoción",
  deposited_member: "Miembro Depositado",
  referred_member: "Miembro Referido",
  validated_on: "Validado en",
  first_deposit: "Primer Depósito",
  reward: "Recompensa",
  inbox: "Bandeja de entrada",
  manual_bonus: "Bono manual",
  review: "Reseña | Reseñas",
  reviews: "Reseñas",
  review_list: "Lista de revisión",
  review_detail: "Detalle de la revisión",
  reply_review: "Revisión de respuesta",
  comment: "Comentario",
  reply: "Respuesta",
  recipient_no: "N.º de destinatario",
  question : "Pregunta",
  rating: "Clasificación",
  content: "Contenido",
  image: "Imagen",
  monthly_rating: "Calificación mensual",
  affiliate: "Afiliado",
  affiliate_list: "Lista de afiliados",
  affiliate_code: "Código de afiliado",
  approved_by: "Aprobado por",
  approved_date: "Fecha de aprobación",
  bank_affiliate: "Filial Bancaria",
  bank_id: "Identificación bancaria",
  ticket_detail_affiliate: "Afiliado de detalles de tickets",
  pending_application: "Solicitud pendiente",
  pending_review_withdrawal: "Retiro pendiente y en revisión",
  unblock_affiliate: "Desbloquear afiliado",
  wallet_adjust: "Ajuste de billetera",
  comm_package: "Paquete de comunicaciones",
  affiliate_id: "ID de afiliado",
  sub_account_detail: "Detalle de la subcuenta",
  daily_winlose_affiliate: "Daily Winlose (Afiliado)",
  daily_deposit_affiliate: "Depósito Diario (Afiliado)",
  export_excel: "Exportar Excel",
  get_tac: "Obtener OTP",
  tac_code: "Código OTP",
  expiry_date: "Fecha de caducidad",
  inactive: "Inactivo",
  last_deposit_date: "Última fecha de depósito",
  coupon: "Cupón",
  allocated: "Asignado",
  claimed: "Reclamado",
  approved: "Aprobado",
  coupon_code: "Código de cupón",
  coupon_quota: "Cuota de cupones",
  current_allocated: "Asignados actuales",
  new_allocated: "Nueva Asignación",
  update : "Actualización",
  copy: "Copiar",
  bonus_rate_percent : "Tasa de bonificación (%)",
  coupon_desc: "Descripción del cupón",
  both: "Ambas",
  issue_free_spin: "Emitir Tirada Gratis",
  game: "Juego",
  max_win_amount: "Cantidad máxima de ganancias",
  utm_list: "Lista UTM",
  search_by_member: "Buscar por miembro",
  campaign: "Campaña",
  deposited: "Depositado",
  search_by_id: "Buscar por ID",
  get_bank_tac: "Obtener OTP del banco",
  bank_statement_daily: "Estado de cuenta bancario (diario)",
  transfer_type: "Tipo de transferencia",
  audit_freebies_list: "Lista de regalos de auditoría",
  acknowledge: "Reconocimiento",
  submit_acknowledgement: "Enviar Acuse de Recibo",
  is_ack: "Es Ack",
  yes: "Sí",
  no: "No",
  audit_rescue_fund_list: "Auditoría de la Lista de Fondos de Rescate",
  global_setting: "Ambientación global",
  signup_ip: "IP de registro",
  last_login_ip: "Última IP de inicio de sesión",
  last_login_time: "Última hora de inicio de sesión",
  link: "Enlace",
  is_default: "es el valor predeterminado",
  is_public: "es público",
  bank_group: "Grupo Bancario",
  set_default: "Establecer valor predeterminado",
  group_id: "ID de grupo",
  group_name: "Nombre del grupo",
  provider_maintenance: "Mantenimiento del proveedor",
  provider_code: "Código de proveedor",
  provider_name: "Nombre del proveedor",
  withdrawal_limit: "Límite de retiro",
  limit_id: "ID de límite",
  limit_name: "Nombre del límite",
  daily_amount: "Cantidad diaria",
  daily_frequency: "Frecuencia diaria",
  promotion_id: "ID de promoción",
  promotion_name: "Nombre de la promoción",
  withhold_bonus: "Bono de retención",
  withhold_amount: "Monto de retención",
  withhold_amt: "Retener Amt",
  max_withdraw_amt: "Retiro máximo amt",
  max_withdraw_amount: "Monto máximo de retiro",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  start_time: "Hora de inicio",
  end_time: "Fin de los tiempos",
  day: "Día | Días",
  coupon_status: "Estado del cupón",
  campaign_id: "ID de campaña",
  campaign_name: "Nombre de la campaña",
  promotion_group: "Grupo de Promoción",
  referee_list: "Lista de árbitros",
  account_verified: "Cuenta verificada",
  verified_date: "Fecha verificada",
  ticket_list: "Lista de entradas",
  vip_id: "ID VIP",
  vip_name: "Nombre Vip",
  self_rebate_rate: "Tasa de reembolso automático (%)",
  downline_rebate_rate: "Tasa de reembolso de línea descendente (%)",
  provider: "Proveedor",
  match_id: "ID de partido",
  home_team: "Equipo local",
  away_team: "Equipo visitante",
  home_team_new: "Nuevo Equipo Local",
  away_team_new: "Nuevo equipo visitante",
  updated_by: "Actualizado por",
  updated_on: "Actualizado el",
  home_score: "Marcador de localía",
  away_score: "Marcador de visitante",
  home_score_new: "Marcador de casa nuevo",
  away_score_new: "Marcador de visitante nuevo",
  team: "Equipo",
  match_time: "Hora del partido",
  match_round: "Ronda de partidos",
  home_group: "Grupo de Origen",
  away_group: "Grupo visitante",
  match: "Partido",
  match_status: "Estado de la coincidencia",
  insert: "Insertar",
  pin: "Alfiler",
  bet_list: "Lista de apuestas",
  result_list: "Lista de resultados",
  bet_id: "ID de apuesta",
  bet_home: "Apuesta a casa",
  bet_away: "Apuesta fuera",
  bet_on: "Apuesta por",
  min_deposit: "Depósito mínimo",
  min_withdrawal: "Retiro mínimo",
  raise_deposit_ticket: "Aumentar ticket de depósito",
  method: "Método",
  one_time_depositor: "Depositante de una sola vez",
  current_month_non_depositor: "Mes en curso No depositante",
  current_month_no_login: "Mes actual sin inicio de sesión",
  ticket_date: "Fecha del billete",
  ftd_amount: "FTD Amt",
  bonus_issue: "Emisión de bonos",
  promotion_summary: "Resumen de la promoción",
  promotion_summary_detail: "Resumen de la promoción (detalle)",
  claim_frequency: "Frecuencia de las reclamaciones",
  provider_list: "Lista de proveedores",
  platform_winlose: "Plataforma Winlose",
  adjustment_amount: "Monto de ajuste",
  referee_count: "Conteo de árbitros",
  category: "Categoría'",
  update_vip: "Actualización VIP",
  promotion_signup: "Registro de la promoción",
  provider_bet_limit: "Límite de apuesta del proveedor",
  update_member_bet_limit: "Actualizar el límite de apuesta de los miembros",
  bet_limit: "Límite de apuesta",
  sports_game: "Deportes/Juego",
  league_name: "Nombre de la liga",
  home_team_name: "Nombre del equipo local",
  away_team_name: "Nombre del equipo visitante",
  wl_status: "Estado de Winlose",
  available_bank_account: "Cuenta Bancaria Disponible",
  group_bank_account: "Cuenta Bancaria del Grupo",
  edit_bank_group: "Editar Grupo Bancario",
  edit_bank_account_group: "Editar grupo de cuentas bancarias",
  redeposit: "Volver a depositar",
  upline: "Línea ascendente",
  downline: "Línea descendente",
  available_promotion: "Promoción disponible",
  group_promotion: "Promoción Grupal",
  edit_promotion_group: "Editar grupo de promoción",
  edit_promotion_group_norm: "Gestionar la promoción en grupo",
  balance_before: "Equilibrio antes",
  balance_after: "Balance Después",
  signup_count: "Recuento de registros",
  verified_count: "Recuento verificado",
  active_member: "Miembro Activo",
  ftd_count: "Recuento de FTD",
  daily_summary_company: "Resumen Diario (Empresa)",
  daily_summary_operator: "Resumen Diario (Operador)",
  daily_summary_member: "Resumen Diario (Miembro)",
  daily_ledger_operator: "Libro Mayor Diario (Operador)",
  bonus_list: "Lista de bonos",
  ltd_date: "Fecha LTD",
  adjustment_log: "Registro de ajuste",
  get_inbox: "Obtener bandeja de entrada",
  is_claimed: "se reclama",
  mix_parlay: "Mix Parlay",
  event: "Evento",
  result_changes_log: "Registro de cambios en los resultados",
  view_detail: "Ver detalle",
  total_referee: "Árbitro Total",
  verified_signup: "Verificado / Registrarse",
  ftd: "FTD | Primer Depósito",
  raw_msg: "Mensaje en bruto",
  unselect_all: "Anular la selección de todo",
  select_all: "Seleccionar todo",
  edit_bet_limit: "Editar límite de apuesta",
  provider_game_off: "Proveedor de juego apagado",
  provider_hot_game: "Juego caliente del proveedor",
  game_id : "ID de juego",
  game_list: "Lista de juegos",
  off_list: "Fuera de la lista",
  provider_rtp: "RTP del proveedor",
  rtp: "RTP",
  signup_date: "Fecha de registro",
  free_credit: "Crédito Gratis",
  downline_rebate: "Reembolso de línea descendente",
  game_rebate: "Reembolso del juego",
  rebate: "Rebaja",
  ftd_date: "Fecha FTD",
  provider_winlose_company: "Proveedor Winlose (Empresa)",
  provider_winlose_operator: "Proveedor Winlose (Operador)",
  already_hit: "Ya golpeado",
  ongoing: "En curso",
  members_export: "Miembro (Exportación)",
  get_recent_deposit: "Obtener depósito reciente",
  recent_deposit: "Depósito Reciente",
  survey_list: "Lista de encuestas",
  modified_on: "Modificado en",
  cms: "CMS",
  announcement_banner: "Banner de anuncio",
  promotion_banner: "Banner de promoción",
  slide_banner: "Banner de diapositivas",
  seo_page: "Página SEO",
  en_title: "Título (EN)",
  cn_title: "Título (NC)",
  local_title: "Título (LOCAL)",
  en_img: "Imagen (ES)",
  cn_img: "Imagen (CN)",
  local_img: "Imagen (LOCAL)",
  before_login: "Antes de iniciar sesión",
  after_login: "Después de iniciar sesión",
  en: "ES",
  move_up: "Subir",
  move_down: "Mover hacia abajo",
  banner_type: "Tipo de banner",
  default_order: "Orden por defecto",
  item_order: "Orden de artículos",
  title: "Título",
  banner_id: "ID de banner",
  order: "Orden",
  body: "Cuerpo",
  en_image: "Imagen (ES)",
  local_image: "Imagen (LOCAL)",
  move: "Muévete",
  en_img_desktop: "Escritorio de imagen (ES)",
  cn_img_desktop: "Escritorio de imagen (CN)",
  local_img_desktop: "Escritorio de imagen (LOCAL)",
  en_img_mobile: "Imagen Móvil (ES)",
  cn_img_mobile: "Imagen Móvil (CN)",
  local_img_mobile: "Imagen Móvil (LOCAL)",
  login_required: "Es necesario iniciar sesión",
  new_window_tab: "Nueva ventana / pestaña",
  current_page: "Página actual",
  target: "Objetivo",
  alt: "Alt",
  href: "Href",
  image_desktop: "Imagen de escritorio",
  image_mobile: "Imagen móvil",
  en_alt: "Alt (EN)",
  local_alt: "Alt (LOCAL)",
  en_href: "Href (EN)",
  local_href: "Href (LOCAL)",
  en_image_desktop: "Imagen de escritorio (EN)",
  active_period: "Período activo",
  en_item: "Ítem (ES)",
  local_item: "Artículo (LOCAL)",
  meta_title: "Meta Título",
  meta_keywords: "Meta palabras clave",
  meta_url: "Meta URL",
  meta_canonical: "Meta Canónico",
  meta_author: "Meta Autor",
  meta_publisher: "Meta Editor",
  meta_lang: "Meta Lang",
  meta_desc: "Meta Desc",
  meta_image: "Meta imagen",
  page: "Página",
  item: "Artículo",
  remove_desktop_image: "Eliminar imagen de escritorio",
  remove_mobile_image: "Eliminar imagen móvil",
  page_name: "Nombre de la página",
  login_date: "Fecha de inicio de sesión",
  ftd_amount_min: "Cantidad mínima de FTD",
  ftd_amount_max: "Cantidad máx. de FTD",
  fl_provider_code: "Primer Proveedor de Lanzamiento",
  fl_game_id: "Primer ID de juego de lanzamiento",
  fl_game_name: "Nombre del primer juego de lanzamiento",
  top_deposit: "Depósito superior",
  top_withdrawal: "Retiro superior",
  top_promotion: "Promoción superior",
  outstanding_balance: "Saldo pendiente",
  last_update_time: "Última hora de actualización",
  trace: "Rastro",
  trace_outstanding: "Rastro Sobresaliente",
  outstanding: "Sobresaliente",
  clear_outstanding: "Claro Pendiente",
  meta_image_url: "URL de la meta imagen",
  member_bonus: "Bono de Miembro",
  crm_list: "Lista de CRM",
  advance_search: "Búsqueda avanzada",
  deposit_count_from: "Recuento de depósitos desde",
  deposit_count_to: "Recuento de depósitos hasta",
  deposit_amount_from: "Monto del depósito desde",
  deposit_amount_to: "Monto del depósito a",
  min_day_no_login: "Min. Día sin inicio de sesión",
  min_day_no_deposit: "Min. Día Sin Depósito",
  last_login: "Último inicio de sesión",
  last_deposit: "Último depósito",
  phone: "Teléfono",
  email: "Correo electrónico",
  ip_whitelist: "Lista blanca de IP",
  ip: "IP",
  payment_option: "Opción de pago",
  payment_mode: "Modo de pago",
  payment_desc: "Desc de pago",
  edit_provider: "Proveedor de edición",
  success: "ÉXITO",
  failed: "FALLIDO",
  bank_member_ewallet: "Miembro del Banco (E-Wallet)",
  processing: "Procesamiento",
  recipient_bank_id: "ID del banco receptor",
  recipient_bank_acc_no: "Nº de cuenta del banco receptor",
  ticket_auto_withdrawal_log: "Registro de tickets (retiro automático)",
  resubmit_ticket: "Volver a enviar ticket",
  ticket_export: "Ticket (Exportación)",
  export_deposit: "Exportación (depósito)",
  export_deposit_all: "Exportar todo (depósito)",
  export_withdrawal: "Exportación (retirada)",
  export_withdrawal_all: "Exportar todo (retirada)",
  export_member_all: "Exportar todo (Miembro)",
  processed_rejected: "Procesado (Rechazado)",
  channel: "Canal",
  influencer: "Influencer",
  ticket_id: "ID de boleto",
  recommend: "Recomendar",
  sequence: "Secuencia",
  statement_info: "Información de la declaración",
  slots: "Tragamonedas",
  livecasino: "Casino en vivo",
  sportsbook: "Apuestas deportivas",
  cockfight: "Pelea de gallos",
  member_list: "Lista de miembros",
  operator: "Operador",
  game_balance: "Equilibrio del juego",
  claim_limit: "Límite de reclamación",
  max_withdraw_multiple: "Múltiplo máximo de retiro",
  payment_gateway: "Pasarela de pago",
  min_limit: "Límite mínimo",
  max_limit: "Límite máximo",
  total: "Total",
  rebate_summary: "Resumen de reembolsos",
  rebate_summary_daily: "Resumen de reembolsos diarios",
  rebate_member: "Miembro de reembolso",
  self: "Yo",
  system_balance: "Equilibrio del sistema",
  rejected_onload: "Rechazado (Onload)",
  no_bonus: "Sin bonificación",
  audit_ticket: "Ticket de auditoría",
  review_ticket: "Revisar Ticket",
  edit_promotion_group_norm_seq: "Administrar la secuencia de promoción en el grupo",
  signup_bonus: "Bono de registro",
  settlement_type: "Tipo de liquidación",
  carry_over: "Trasladar",
  comm_sports: "Comisión (Deportes)",
  comm_slots: "Comisión (Tragamonedas)",
  comm_livecasino: "Comisión (Livecasino)",
  comm_cockfight: "Comisión (Pelea de gallos)",
  comm_others: "Comisión (Otros)",
  update_comm: "Comisión de Actualización",
  update_carry_over: "Transferencia de actualización",
  ewallet: "Billetera electrónica",
  withdrawal_list: "Lista de retiros",
  audit_withdrawal: "Retiro de auditoría",
  daily_withdrawal: "Retiro diario",
  adjustment_log_affiliate: "Registro de ajuste",
  daily_statement_affiliate: "Estado de cuenta diario (afiliado)",
  earning: "Ganancia",
  pnl: "Pérdidas y ganancias",
  review_affiliate_ticket: "Revisar Ticket de Afiliado",
  audit_affiliate_ticket: "Auditar Ticket de Afiliado",
  turnover_downline: "Volumen de negocios (línea descendente)",
  valid_turnover_downline: "Volumen de negocios válido (línea descendente)",
  winlose_downline: "WinLose (línea descendente)",
  bet_count_downline: "Recuento de apuestas (línea descendente)",
  turnover_member: "Volumen de negocios (Miembro)",
  valid_turnover_member: "Volumen de negocios válido (miembro)",
  winlose_member: "WinLose (Miembro)",
  bet_count_member: "Recuento de apuestas (miembro)",
  dashboard_affiliate: "Panel de control (afiliado)",
  total_agent: "Agente Total",
  top_turnover: "Rotación máxima",
  bonus_count: "Recuento de bonos",
  deposit_amount_downline: "Monto del depósito (línea descendente)",
  deposit_count_downline: "Recuento de depósitos (línea descendente)",
  bonus_amount_downline: "Monto del bono (línea descendente)",
  bonus_count_downline: "Conteo de bonificaciones (línea descendente)",
  deposit_amount_member: "Monto del Depósito (Miembro)",
  deposit_count_member: "Cuenta de depósitos (miembro)",
  bonus_amount_member: "Monto del Bono (Miembro)",
  bonus_count_member: "Conteo de Bonos (Miembro)",
  verified: "Verificado",
  round_id: "ID redondo",
  unfinish_round: "Ronda de desacabado",
  smartico_bonus_report: "Informe de bonificación de Smartico",
  unclaimed_amount: "Cantidad no reclamada",
  claimed_amount: "Importe reclamado",
  unclaimed_count: "Recuento no reclamado",
  claimed_count: "Conde reclamado",
  submit_time: "Fecha de creación",
  deposit_time: "Fecha de modificación",
  funds_list: "Lista de entradas",
  daifu_list_auto_withdrawal: "Lista de entradas (retiro automático)",
  btn_href: "Botón Href",
  btn_text: "Texto del botón",
  recent_inbox_claim: "Reclamación reciente de la bandeja de entrada",
  raise_deposit_ticket_gateway: "Levantar Ticket de Depósito (Gateway)",
  gateway_acc: "Cuenta de puerta de enlace",
  provider_winlose_member: "Proveedor Winlose (Miembro)",
  review_by: "Reseña de",
  daifu_list_auto_withdrawal_export: "Exportación de Tickets (Retiro Automático)",
  retention: "Retenton",
  current_month_active_user: "Usuario activo del mes actual",
  current_month_active: "Mes actual activo",
  first_month: "Primer mes",
  fmwinlose: "FMWinlose",
  fmdeposit_amount: "Cantidad de FMDeposit",
  cohort: "Cohorte",
  promotion_withdrawal_summary: "Resumen de Retiro de la Promoción",
  unique_player: "Jugador único",
  year: "Año | Años",
  audit_time_modified: "Fecha de modificación",
  audit_time_created: "Fecha de creación",
  approve_time: "Fecha de modificación",
  unique_login_count: "Recuento de inicios de sesión únicos",
  unique_deposit_count: "Recuento único de depósitos",
  unique_withdrawal_count: "Recuento único de retiros",
  second_deposit_count: "Recuento de segundo depósito",
  unique_login: "Inicio de sesión único",
  unique_withdrawal: "Retiro único",
  second_deposit: "Segundo Depósito",
  deposit_withdrawal_different: "Retiro de depósito diferente",
  ngr: "NGR",
  audit_list: "Lista de auditoría",
  rollback_count: "Recuento de reversiones",
  rejected_ticket_id: "ID de boleto rechazado",
  rollback: "Reversión",
  recipient_bank_acc_holder: "Titular de la cuenta bancaria receptora",
  reject_date: "Fecha de rechazo",
  processing_date: "Fecha de procesamiento",
  manual_approve: "Aprobar (Manual)",
  pending_review_funds: "Pendiente y Ticket de Revisión",
  table_id: "ID de la tabla",
  member_label: "Etiqueta de miembro",
  label_name: "Nombre de la etiqueta",
  label: "Etiqueta",
  available_label: "Etiqueta disponible",
  iframe: "Iframe",
  iframe_url: "URL de iframe",
  exchange_rate: "Tipo de cambio",
  rate: "Tarifa",
  rate_php: "Tasa PHP",
  ticket_withdrawal_rollback: "Reversión de retiro de boletos",
  smartico_bonus_report_expired: "Informe de bonificación Smartico (caducado)",
  reward_type: "Tipo de recompensa",
  turnover_rebate: "Descuento sobre el volumen de negocios",
  turnover_rebate_1: "Nivel VIP",
  turnover_rebate_2: "Nivel de facturación",
  vip_cycle_day: "Día de Ciclismo VIP",
  is_addon: "es un complemento",
  no_reward: "Sin recompensa",
  cash: "Efectivo",
  cs: "Servicio de Atención al Cliente",
  social_platform: "Plataforma Social",
  edit_vip: "Editar VIP",
  edit_vip_provider: "Editar proveedor VIP",
  turnover_tier: "Nivel de facturación",
  rebate_rate: "Tasa de reembolso",
  edit_turnover_tier: "Editar nivel de facturación",
  delete_turnover_tier: "Eliminar nivel de facturación",
  vip_log: "Registro VIP",
  member_full_record: "Registro completo de miembros",
  before: "Antes",
  after: "Después",
  maintain: "Mantener",
  actual_rebate: "Reembolso real",
  rounded_rebate: "Descuento redondeado",
  rebate_mode: "Modo de reembolso",
  inbox_id: "ID de bandeja de entrada",
  rebate_type: "Tipo de reembolso",
  promotion_type: "Tipo de promoción",
  bonus_rate_1: "Tasa 1(%)",
  bonus_rate_2: "Tasa 2(%)",
  bonus_rate_3: "Tasa 3(%)",
  bonus_rate_4: "Tasa 4(%)",
  bonus_rate_5: "Tasa 5(%)",
  bonus_rate_6: "Tasa 6(%)",
  bonus_rate_7: "Tasa 7(%)",
  bonus_rate_8: "Tasa 8(%)",
  bonus_rate_9: "Tasa 9(%)",
  bonus_rate_10: "Tasa 10(%)",
  delete_all: "Eliminar todo",
  rescue_fund: "Fondo de Rescate",
  up: "Arriba",
  down: "Abajo",
  rate_percent: "Tasa %",
  cycle: "Ciclo",
  actual_amount: "Importe real",
  rounded_amount: "Importe redondeado",
  rescue_id: "Identificación de rescate",
  rescue_name: "Nombre de rescate",
  min_lose: "Min Lose",
  max_payout: "Pago máximo",
  payout_method: "Método de pago",
  target_group: "Grupo destinatario",
  member_vip_id: "ID VIP de miembro",
  daily: "A diario",
  weekly: "Semanal",
  monthly: "Mensual",
  edit_batch: "Editar lote",
  current_level: "Nivel actual",
  next_level: "Siguiente nivel",
  bet_value: "Valor de la apuesta",
  line_bet: "Apuesta de línea",
  total_round: "Ronda total",
  audit_by: "Auditoría por",
  possible_next_level: "Posible Siguiente Nivel",
  maintain_deposit: "Mantener el depósito",
  maintain_turnover: "Mantener la rotación",
  starting_deposit: "Depósito inicial",
  starting_turnover: "Rotación inicial",
  cycle_deposit: "Depósito de ciclos",
  cycle_turnover: "Rotación del ciclo",
  vip_list: "Lista VIP",
  up_maintain: "Mantener hacia arriba",
  down_lowest: "Abajo lo más bajo",
  manual: "Manual",
  daily_winlose_game: "Ganaruno diario (Juego)",
  actionaff: "Acción (Afiliado)",
  onload: "Carga",
  update_status: "Estado de actualización",
  role_settings: "Configuración de roles",
  customer_services: "Servicio de Atención al Cliente",
  marketing: "Comercialización",
  finance: "Finanzas",
  risk_management: "Gestión de Riesgos",
  pt: "PT",
  wallet_history: "Historial de la billetera",
  ticket_amount: "Importe del billete",
  ignore_risk: "Ignorar el riesgo",
  permitted_amount: "Cantidad permitida",
  all_pending_ticket: "Todos los tickets pendientes",
  rescue_fund_summary: "Resumen del Fondo de Rescate",
  rescue_fund_summary_daily: "Resumen Diario del Fondo de Rescate",
  rescue_fund_member: "Miembro del Fondo de Rescate",
  master: "Maestro",
  account_type: "Tipo de cuenta",
  freeze: "Congelar",
  domain_member_setup: "Configuración de dominio del sitio miembro",
  domain: "Dominio",
  domain_list: "Lista de dominios",
  domain_application: "Aplicación de dominio",
  domain_status: "Estado del dominio",
  domain_group: "Grupo de dominio",
  operator_id: "ID de operador",
  domain_type: "Tipo de dominio",
  module: "Módulo",
  template: "Plantillas",
  custom: "Personalizado",
  default: "Predeterminado",
  payment_provider: "Proveedor de pagos",
  payment: "Pago",
  deactivate: "Inactivo",
  name_server: "Servidor de nombres",
  server_account: "Cuenta de servidor",
  service_provider: "Proveedor de servicios",
  process: "Proceso",
  provider_operator: "Operador Proveedor",
  bet_limit_member: "@:ui.bet_limit (@:ui.member)",
  global: "Configuración global",
  second_id: "Segunda identificación",
  unverified: "Sin verificar",
  pt_affiliate: "Cargos de la plataforma de afiliados (%)",
  recipient_bank: "Banco Receptor",
  deposit_type: "Tipo de depósito",
  security_fund: "Fondo de Seguridad",
  adjust_balance_op: "Ajustar la billetera del operador",
  adjust_security_deposit_op: "Ajustar el Fondo de Seguridad del Operador",
  marquee: "Carpa",
  marquee_content: "Contenido de la marquesina",
  edit_marquee: "Editar marquesina",
  domain_available: "Dominio disponible",
  daily_withdrawal_frequency: "Frecuencia de retiro diario",
  maintenance: "Mantenimiento",
  max_withdrawal: "Retiro máximo",
  min_balance: "Saldo mínimo",
  affiliate_report: "Informes de afiliados",
  cash_balance: "Saldo de caja",
  copy_success: "¡Copia con éxito!",
  copy_failed: "¡Copia fallida!",
  your_website: "Su sitio web",
  correction_promo: "Corrección (Promoción)",
  others: "Otros",
  audit_log: "Registro de auditoría",
  view: "Vista",
  price: "Precio",
  package_level: "Nivel de paquete",
  bo_right: "BO Correcto",
  english: "Inglés",
  simplified_chinese: "Chino (CN)",
  traditional_chinese: "Chino (TW)",
  philippine: "Filipinas",
  thai: "Tailandés",
  vietnamese: "vietnamita",
  indonesian: "Indonesio",
  myanmar: "Myanmar",
  japanese: "Japonés",
  korean: "Coreano",
  package_type: "Tipo de paquete",
  full_back_office_access_right: "Derecho de acceso completo a la oficina administrativa",
  read_only_back_office: "Back Office de solo lectura",
  language: "Idioma",
  lang_code: "Código lingüístico",
  description: "Descripción",
  provider_type: "Tipo de proveedor",
  logo: "Logotipo",
  theme_provider: "Proveedor de temas",
  theme_content: "Contenido del tema",
  content_id: "ID de contenido",
  content_desc: "Descripción de contenido",
  theme_content_position: "Posición del contenido del tema",
  theme: "Tema",
  theme_code: "Código del tema",
  theme_name: "Nombre del tema",
  color: "Color",
  position: "Posición",
  site_name: "Nombre del sitio",
  theme_color: "Color del tema",
  theme_purchased: "Tema comprado",
  total_purchased: "Total Comprado",
  purchased_date: "Fecha de compra",
  purchase: "Compra",
  total_site: "Sitio Total",
  content_setup: "Configuración de contenido",
  site_list: "Lista de sitios",
  site_id: "ID del sitio",
  draft_version: "Versión preliminar",
  prod_version: "Versión Prod.",
  production_version: "Versión de producción",
  info: "Información",
  setting: "Ambientación",
  site_info: "Información del sitio",
  menu: "Menú",
  game_menu: "Menú de juego",
  special_menu: "Menú Especial",
  setting_menu: "Menú de configuración",
  error: "Error",
  sync_all: "Sincronizar todo",
  theme_content_group: "Grupo de contenido temático",
  content_group: "Grupo de contenido",
  content_group_desc: "Desc del grupo de contenido",
  parent_content_id: "ID de contenido principal",
  bo_default_domain: "Dominio predeterminado BO",
  domain_id: "ID de dominio",
  deactive: "Desactivar",
  site_sync: "Sincronización del sitio",
  upload: "Subir",
  comingSoon: "Próximamente",
  profile_setting: "Configuración de perfil",
  bank: "Banco",
  company: "Empresa",
  own: "PROPIO",
  operator_setting: "Configuración del operador",
  external_id: "ID externo",
  ticket: "Billete",
  bank_owner: "Propietario del Banco",
  exchanged_currency: "Moneda cambiada",
  company_bank_owner: "Propietario del banco de la empresa",
  ticket_list_member: "Lista de Entradas (Miembro)",
  game_name_exclude: "Excluir nombre del juego",
  tab: "Tabulador",
  about_us: "Sobre nosotros",
  privacy_policy: "Política de privacidad",
  responsible_gaming: "Juego responsable",
  banking: "Banca",
  faqs: "Preguntas frecuentes",
  advertisement: "Publicidad",
  px_pixel_id: "ID de píxel PX",
  px_token: "Ficha PX",
  af_dev_key: "Af Dev Key",
  af_apps_id: "ID de aplicaciones AF",
  pp_tid: "PP TID",
  pp_pid: "PP PID",
  pp_aid: "PP AYUDA",
  gtm_id: "ID de GTM",
  service_provider_url: "URL del proveedor de servicios",
  script_inject: "Inyección de script",
  head_script: "Guión principal",
  body_script: "Guión del cuerpo",
  ads_id: "ID de anuncios",
  member_detail: "Detalle del miembro",
  memberreport: "Informe de Miembro",
  member_log: "Registro de miembros",
  general: "Generalidades",
  top_theme: "Tema principal",
  hot_game: "Juego caliente",
  hot_list: "Lista caliente",
  new_game: "Nuevo juego",
  popular_game: "Juego Popular",
  featured_game: "Juego destacado",
  new_list: "Nueva Lista",
  popular_list: "Lista Popular",
  featured_list: "Lista de destacados",
  provider_new_game: "Proveedor Nuevo juego",
  provider_popular_game: "Proveedor de juegos populares",
  provider_featured_game: "Juego destacado del proveedor",
  website: "Sitio web",
  site_customization: "Personalización del sitio",
  export_all: "Exportar todo",
  export_one: "Exportar (página actual)",
  daily_ledger: "Libro de contabilidad diario",
  daily_ledger_member: "Daily Ledger (Miembro)",
  promotion_signup_unused: "Promoción de registro no utilizada",
  promotion_signup_ongoing: "Promoción de registro en curso",
  promotion_signup_winlose: "Promoción de registro Winlose",
  promotion_signup_winlose_operator: "Promoción de registro winlose (operador)",
  promotion_signup_winlose_member: "Promoción de registro winlose (miembro)",
  total_player_balance: "Saldo total del jugador",
  search_all: "Buscar todo",
  mbsetting: "Ajustes",
  todays_highlights: "Lo más destacado de hoy",
  deposit_player: "Jugador de depósito",
  withdrawal_player: "Jugador de retiro",
  kill_rate: "Tasa de muertes",
  login_player: "Iniciar sesión en el reproductor",
  operation_management: "Operación",
  game_management: "Juego",
  member_management: "Miembro",
  affiliate_management: "Afiliado",
  promotion_management: "Promoción",
  mbcampaign: "Campaña",
  promo_allday: "Todo el día",
  promo_daily: "A diario",
  promo_daily_first_deposit: "Primer Depósito Diario",
  promo_deposit_monthly: "Recuento de depósitos mensuales",
  promo_deposit_signup: "Registro de conteo de depósitos",
  promo_deposit_weekly: "Recuento de depósitos semanal",
  promo_newbie: "Novato",
  promo_once: "Una vez",
  dd_review: "Revisión",
  game_provider_management: "Proveedor",
  exchanged_amount: "Importe intercambiado",
  operator_summary: "Resumen del operador",
  business_id: "Identificación de la empresa",
  game_name_exclude_log: "Registro de exclusión de nombre de juego",
  cn: "CN",
  local: "LOCAL",
  taken: "Tomado",
  receiver_bank: "Banco receptor",
  receiver_bank_acc_no: "Nº de cuenta del banco receptor",
  receiver_bank_acc_holder: "Titular de la cuenta del banco receptor",
  add_balance: "Agregar saldo",
  deduct_balance: "Deducir saldo",
  sync_site_content: "Sincronizar el contenido del sitio",
  payment_setting: "Configuración de pago",
  payment_own: "PROPIO",
  payment_global: "GLOBAL",
  livechat: "Chat en vivo",
  chat_id: "Clave de licencia de LiveChat",
  chat_provider: "Proveedor de LiveChat",
  auto_cycle: "CICLO",
  auto_all: "TODOS",
  completed_amount: "Cantidad completada",
  website_launched: "Lanzamiento del sitio web",
  total_operators: "Total de operadores",
  today_active: "Hoy activo",
  new_player_verified_signup: "Nuevo jugador verificado/Registrarse",
  total_players: "Total de jugadores",
  depo_withdrawal_diff: "Diferencia DEPO-WITH",
  claim_count: "Recuento de reclamaciones",
  ggr: "GGR",
  member_balance: "Saldo de miembros",
  players: "Jugadores",
  provider_pt: "Proveedor PT",
  base: "Base",
  topup_id: "ID de recarga",
  credential: "Credencial",
  credential_1: "Credencial 1",
  credential_2: "Credencial 2",
  credential_3: "Credencial 3",
  credential_4: "Credencial 4",
  credential_5: "Credencial 5",
  credential_6: "Credencial 6",
  credential_7: "Credencial 7",
  credential_8: "Credencial 8",
  credential_9: "Credencial 9",
  credential_10: "Credencial 10",
  limit: "Límite",
  create: "Crear",
  hint: "Pista",
  quickSetup: "Configuración rápida",
  next: "Siguiente",
  setUpTheme: "Tema de configuración",
  checkOut: "Echa un vistazo",
  standardPackage: "Paquete Estándar",
  siteName: "Nombre del sitio",
  information: "Información",
  useThisTemplate: "Usar esta plantilla",
  summary: "Resumen",
  createOperatorAccount: "Crear cuenta de operador",
  operatorId: "ID de operador",
  operatorPwd: "Espada de operador",
  new_website: "Nuevo sitio web",
  operator_information: "Información del operador",
  bo_link: "Enlace BO",
  daily_summary_sms: "SMS de resumen diario",
  daily_summary_sms_operator: "Resumen diario del operador de SMS",
  daily_summary_sms_operator_detail: "Resumen diario del detalle del operador de SMS",
  sms_count: "Recuento de SMS",
  provider_winlose_operator_pt: "Proveedor Winlose (Operador PT)",
  pt_on: "PT Encendido",
  share_operator: "Operador de acciones",
  share_company: "Sociedad Anónima",
  token_log: "Registro de tokens",
  template_code: "Código de plantilla",
  template_name: "Nombre de la plantilla",
  mini_game: "Minijuego",
  max_game_reward: "Recompensa máxima del juego",
  max_chance_per_day: "Probabilidad máxima por día",
  is_recurring_chance: "Recurrente",
  token_request: "Ficha",
  enabled: "Habilitado",
  disabled: "Desactivado",
  unlimited: "Ilimitado",
  max_chance_unlimited: "Probabilidad máxima por día ilimitada",
  mini_game_template: "Plantilla de minijuego",
  reward_code: "Código de recompensa",
  reward_name: "Nombre de la recompensa",
  reward_description: "Descripción de la recompensa",
  reward_probability: "Probabilidad de recompensa",
  total_game: "Juego Total",
  total_played_mini_game: "Minijuego total jugado",
  total_played_mini_game_detail: "Detalle total del minijuego jugado",
  total_played_mini_game_detail_operator: "Detalle del minijuego total jugado (operador)",
  daily_pnl_operator: "Pérdidas y ganancias diarias (operador)",
  token: "Ficha",
  token_1: "Ficha 1",
  token_2: "Ficha 2",
  token_3: "Ficha 3",
  token_4: "Ficha 4",
  token_5: "Ficha 5",
  token_6: "Ficha 6",
  token_7: "Ficha 7",
  cash_1: "Efectivo 1",
  cash_2: "Efectivo 2",
  cash_3: "Efectivo 3",
  cash_4: "Efectivo 4",
  cash_5: "Efectivo 5",
  cash_6: "Efectivo 6",
  cash_7: "Efectivo 7",
  daily_login: "Check-in diario (inicio de sesión diario)",
  daily_login_update: "Actualización diaria de check-in (inicio de sesión diario)",
  game_result_reward: "Resultado del juego (recompensa)",
  current_streak: "Racha actual",
  login_streak: "Racha de inicio de sesión",
  total_token: "Token total",
  total_mini_game_token_used: "Total de fichas de minijuego utilizadas",
  total_mini_game_token_used_detail: "Detalle total de la ficha de minijuego utilizada",
  total_mini_game_token_used_detail_operator: "Detalle total de fichas de minijuego utilizadas (operador)",
  total_reward: "Recompensa total",
  total_mini_game_reward: "Recompensa total del minijuego",
  total_mini_game_reward_detail: "Detalle total de la recompensa del minijuego",
  total_mini_game_reward_detail_operator: "Detalle de la recompensa total del minijuego (operador)",
  token_balance: "Saldo de tokens",
  free_game_token: "Ficha de Juego Gratis",
  bo_url: "URL de backoffice",
  copied: "Copiado",
  callback: "Devolución de llamada",
  api: "API",
  prefix: "Prefijo",
  delimiter: "Delimitador",
  url_callback_deposit: "URL de devolución de llamada de depósito",
  url_callback_withdrawal: "URL de devolución de llamada de retiro",
  url_callback_affiliate: "URL de devolución de llamada de afiliado",
  url_api_deposit: "URL de devolución de llamada de depósito (API)",
  url_api_withdrawal: "URL de devolución de llamada de retiro (API)",
  url_api_balance: "URL de devolución de llamada de saldo (API)",
  prefix_deposit: "Prefijo de depósito",
  prefix_withdrawal: "Prefijo de retiro",
  prefix_affiliate: "Prefijo de afiliado",
  prefix_delimiter: "Prefijo delimitador",
  merchant: "Comerciante",
  app_id: "ID de la aplicación",
  secret_key: "Clave secreta",
  deposit_secret_key: "Depositar clave secreta",
  withdrawal_secret_key: "Clave secreta de retiro",
  partners: "Socios",
  partner_name: "Nombre del socio",
  win: "Ganar",
  manifest: "Manifiesto",
  crop: "Cultivo",
  cropImage: "Recortar imagen",
  api_url: "URL de la API",
  start_date_time: "Fecha y hora de inicio",
  end_date_time: "Fecha y hora de finalización",
  authentication_key: "Clave de Autenticación",
  one_week: "1 semana",
  two_week: "2 semanas",
  one_month: "1 mes",
  two_month: "2 meses",
  six_month: "6 meses",
  edit_promotion_end_date: "Editar fecha de finalización de la promoción",
  android_app_link: "Enlace de la app de Android",
  add_android_app_link: "Agregar enlace de la app de Android",
  operator_details: "Detalles del operador",
  bsb: "BSB",
  payid: "Pay ID",
  cuit: "CUIT",
  merchant_key: "Clave del Comerciante",
  aes_key: "Clave AES",
  paycode: "Código de Pago",
  api_key: "Clave API",
  referral: "Referencia",
  minimum_deposit: "Depósito mínimo",
  minimum_withdrawal: "Retiro mínimo",
  maximum_withdrawal: "Retiro máximo"
}